/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2019
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/

const constructNode = attributes => {
  const node = {};
  node.node_id = attributes.dialog_node;
  node.dialog_node = attributes.dialog_node;
  node.type = attributes.type;
  node.description = attributes.description;
  node.conditions = attributes.conditions;
  node.output = attributes.output
    ? attributes.output
    : attributes.type === 'folder'
    ? undefined
    : {};
  node.context = attributes.context;
  node.created = attributes.created;
  node.user_label = attributes.user_label;
  node.updated = attributes.updated;

  if (/^(node_[0-9]+_[0-9]+)$/.test(attributes.dialog_node) === false) {
    node.name = attributes.dialog_node;
  }

  if (attributes.parent_id) {
    node.parent = attributes.parent_id;
  } else {
    node.parent = attributes.parent;
  }

  if (attributes.previous_sibling_id) {
    node.previous_sibling = attributes.previous_sibling_id;
  } else {
    node.previous_sibling = attributes.previous_sibling;
  }

  if (attributes.metadata) {
    node.metadata = attributes.metadata;
  }

  if (attributes.actions) {
    node.actions = attributes.actions || [];
  }

  if (attributes.go_to) {
    node.next_step = {
      behavior: 'jump_to',
      dialog_node: attributes.go_to.dialog_node,
      selector: attributes.go_to.selector
    };
  }
  if (attributes.next_step) {
    node.next_step = attributes.next_step;
  }

  if (attributes.event_name) {
    node.event_name = attributes.event_name;
  }
  if (attributes.variable && attributes.variable !== ' ') {
    node.variable = attributes.variable;
  }
  if (attributes.disabled) {
    node.disabled = attributes.disabled;
  }

  // Digressions
  if (attributes.digress_in || attributes.digress_in === null) {
    node.digress_in = attributes.digress_in;
  }
  if (attributes.digress_out) {
    node.digress_out = attributes.digress_out;
  }
  if (
    (attributes.digress_out_slots && attributes.type === 'frame') ||
    attributes.digress_out_slots === null
  ) {
    node.digress_out_slots = attributes.digress_out_slots;
  }

  if (attributes.title) {
    node.title = attributes.title;
    node.name = attributes.title;
  } else if (attributes.conditions) {
    node.name = attributes.conditions;
  }

  // Disambiguation
  if (attributes.disambiguation_opt_out) {
    node.disambiguation_opt_out = attributes.disambiguation_opt_out;
  }
  return node;
};

export function nodeFactory(attributes) {
  return constructNode(attributes);
}

export function nodesFactory(nodes) {
  if (nodes && typeof nodes.map === 'function') {
    return nodes.map(node => nodeFactory(node));
  }
}
